import {
  useMutation,
  UseMutationOptions,
  DefaultError
} from '@tanstack/react-query';

import {
  postLogin,
  PostLoginQuery,
  PostLoginResponse
} from '~/lib/services/api/user';
import { PostLoginRequest } from '~/modules/login/login-form/constants';

function useLogin () {
  const mutationFn: PostLoginQuery = async (newData) => {
    const response = await postLogin(newData);
    return response.data;
  };

  const options: UseMutationOptions<
    PostLoginResponse,
    DefaultError,
    PostLoginRequest,
    unknown
  > = {
    mutationFn
  };

  return useMutation(options);
}

export default useLogin;
